import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getZipcode } from 'helpers/Zipgate';
import { RootState } from 'redux/store';
const Acr = window.Acr || undefined;
let initialState: string = Acr
  ? Acr.zipgateComponent.getZipcode()
  : getZipcode();
export const zipcodeSlice = createSlice({
  name: 'zipcode',
  initialState,
  reducers: {
    setZipcode: (state, action: PayloadAction<string>) => {
      localStorage.setItem('userZipCode', action.payload);
      return (state = action.payload as string);
    },
  },
});

export const { setZipcode } = zipcodeSlice.actions;

export const selectZipcode = (state: RootState) => state.zipcode;

export default zipcodeSlice.reducer;
